import { render, staticRenderFns } from "./ProductSummaryPane.vue?vue&type=template&id=f28fdf3c&"
import script from "./ProductSummaryPane.vue?vue&type=script&lang=js&"
export * from "./ProductSummaryPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports